/**
 * @param {*} path 模块地址
 * @param {*} msg 语言包
 */
export const formatDocumentTitle = (path, msg) => {
  switch (path) {
    // 合约模块
    case '/aboutIndex' :
      document.title = `${msg.contractManagementMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/aboutIndex/aboutDetails' :
      document.title = `${msg.contractDetailMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 运价模块
    case '/freight/freightProprietary' :
      document.title = `${msg.contractRateMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/freight/freightOnline' :
      document.title = `${msg.eCommerceRateMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/freight/freightPeer' :
      document.title = `${msg.offlineRateMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/freight/freightAll' :
      document.title = `${msg.rateTotalTableMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/freight/freightRecords' :
      document.title = `${msg.rateRecordsMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/freight/freightDetails' :
      document.title = `${msg.rateDetailMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/freight/freightRecordsDetails' :
      document.title = `${msg.rateDetailMenu}-${msg.rateRecordsDetails}`
      break
    case '/offlineRate' :
      document.title = `${msg.offlineRateMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 附加费模块
    case '/surcharge/surchargeRules' :
      document.title = `${msg.surchargeRulesMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/surcharge/surchargeRulesDetails' :
      document.title = `${msg.surchargeRuleDetailMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/surcharge/surchargeDetails' :
      document.title = `${msg.surchargeDetailsMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/surcharge/inlandFreight' :
      document.title = `${msg.inlandFreightMenuNew}-${msg.rateMiddleOfficeMenu}`
      break
    // 内陆运费
    case '/inlandCarriage' :
      document.title = `${msg.inlandFreightMenuNew}-${msg.rateMiddleOfficeMenu}`
      break
    case '/inlandCarriage/inlandDetails' :
      document.title = `${msg.inlandFreightDetails}-${msg.rateMiddleOfficeMenu}`
      break
    // 分销模块
    case '/cabin/cabinList' :
      document.title = `${msg.distributionRateMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/cabin/cabinDetails' :
      document.title = `${msg.distributionDetailMenu}-${msg.rateMiddleOfficeMenu}`
      break
    case '/cabin/CabinRules' :
      document.title = `${msg.distributionMarkupTitle}-${msg.rateMiddleOfficeMenu}`
      break
    case '/cabin/cabinAutomatic' :
      document.title = `${msg.automaticDistributionRateMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 标签模块
    case '/tag' :
      document.title = `${msg.tagManagement}-${msg.rateMiddleOfficeMenu}`
      break
    // 订阅
    case '/subscribe' :
      document.title = `${msg.rateSubscribed}-${msg.rateMiddleOfficeMenu}`
      break
    // 加价
    case '/premium' :
      document.title = `${msg.markupManagement}-${msg.rateMiddleOfficeMenu}`
      break
    // 免箱期
    case '/free' :
      document.title = `${msg.freeDetentionMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 免箱期详情
    case '/freeDetails' :
      document.title = `${msg.freeDetentionDetailMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 预订舱
    case '/prebooking' :
      document.title = `${msg.prebookingMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 散杂货船期
    case '/bulkCargo' :
      document.title = `${msg.generalCargoSchedule}-${msg.rateMiddleOfficeMenu}`
      break
    case '/prebooking/prebookingDetails' :
      document.title = `${msg.prebookingDetailMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 系统设置
    case '/systemSetting' :
      document.title = `${msg.systemSettingMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 上传记录
    case '/uploadList' :
      document.title = `${msg.uploadRecordMenu}-${msg.rateMiddleOfficeMenu}`
      break
    // 查询记录
    case '/queryLog' :
      document.title = `${msg.searchRecs}-${msg.rateMiddleOfficeMenu}`
      break
    // 默认显示运价中台
    default:
      document.title = msg ? msg.rateMiddleOfficeMenu : '运价中台'
  }
}
